import React from 'react'

function LastNew() {
  return (
    
    <div className='lastnew'>
    <div className='newcontent'>
      <img alt="" src="https://www.shutterstock.com/shutterstock/photos/1883859943/display_1500/stock-photo-the-word-example-is-written-on-a-magnifying-glass-on-a-yellow-background-1883859943.jpg"></img>
     <div className='w-100 d-flex justify-content-center'>
      <label>asdas</label>
     </div>
    </div>  
    </div>
  )
}

export default LastNew
